<div class="ComparisonBanner" data-testid="comparison-banner">
  <div class="ComparisonBanner__header" i18n="@@comparison-banner.instructions">My List ({{assets().length}})</div>
  <div class="ComparisonBanner__content">
    <div class="ComparisonBanner__carousel">
      <app-icon-button
        class="nav-button nav-button--prev"
        [class]="carouselId() + '-prev'"
        icon-btn-small
        icon-btn-icon-large
        icon-btn-icon-only
        data-testid="prev-button"
        [matIcon]="'keyboard_arrow_left'"
      />
      <swiper-container
        #swiperContainer
        init="false"
      >
        @for (asset of assets(); track $index) {
          <swiper-slide class="asset-carousel__item" data-testid="swiper-slide">
            <app-comparison-card
              [asset]="asset"
              [defaultImage]="globalDataService.defaultImage()"
              [currencyCode]="globalDataService.selectedCurrency().code"
              (clearClicked)="clearAsset(asset)"
              data-testid="comparison-card"
            />
          </swiper-slide>
        }
      </swiper-container>
      <app-icon-button
        class="nav-button nav-button--next"
        [class]="carouselId() + '-next'"
        icon-btn-small
        icon-btn-icon-large
        icon-btn-icon-only
        data-testid="next-button"
        [matIcon]="'keyboard_arrow_right'"
      />
    </div>
    <app-button
      class="action-button action-button__clear"
      btn-medium
      btn-secondary
      btn-outlined
      (click)="clearAll()"
      i18n="@@general.clear-all-button.label"
    >Clear all</app-button>
    <app-icon-button
      class="action-button action-button__compare"
      icon-btn-outlined
      icon-btn-responsive="small"
      icon-btn-icon-responsive="large"
      icon-btn-secondary
      data-testid="comparison-toggle"
      [disabled]="assets().length < 1"
      [matIcon]="'keyboard_arrow_up'"
      (click)="compare()"
    />
  </div>
</div>